/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').factory('MenuStatView', ["$filter",
    function ($filter) {
        var MenuStatView = function (view, code, label, parent, $scope) {
            this.view = view;
            this.code = code;
            this.label = label;
            this.scope = $scope;
            this.parentMenuStatView = parent;
            this.menuStatsView = [];
            this.object = null;
            this.icon = "fa-chevron-right";
            this.tab = 1;
            this.sort = "";
            this.sortReverse = false;


        };

        MenuStatView.prototype.getByCode = function (code)//
        {
            if (this.code == code)
                return this;
            var menu = null;
            for (var i = 0; i < this.menuStatsView.length && !menu; i++)
                menu = this.menuStatsView[i].getByCode(code);
            return menu;

        };
        MenuStatView.prototype.getByObject = function (object)//
        {
            if (this.object === object)
                return this;
            var menu = null;
            for (var i = 0; i < this.menuStatsView.length && !menu; i++)
                menu = this.menuStatsView[i].getByObject(object);
            return menu;

        }
        MenuStatView.prototype.getSum = function () {
            var sum = 0
            for (var i = 0; i < this.menuStatsView.length; i++)
                if (this.menuStatsView[i].object) {
                    sum += this.menuStatsView[i].object.ca;
                }
            return sum;
        }
        return MenuStatView;
    }]);



// WEBPACK FOOTER //
// ./js/services/views/statistics/MenuStatView.js